import React, { ReactNode } from 'react'
import { SerializedStyles } from '@emotion/core'
import styled from '@emotion/styled'

//jelly
import { Content } from '@jelly/components'

import * as Components from './Components'

// Styled Components via Emotion
const ContentWrapper = styled.div`
	height: auto;
	width: 100%;
`
//The node can be just a string (text nodes)
type NodeString = Node | string

interface Node {
	children?: NodeString[]
	component: string
	//some elements will not have props
	props?: {
		[k: string]: string | object
	}
}

export type KeysComponents = keyof typeof Components

const createChildren = (
	//Array of children
	children: NodeString[],
	//Only the keys of the Component module are allowed
	data: { [k in KeysComponents]?: any },
	styles: SerializedStyles[]
): ReactNode[] => {
	return children.map(
		(node): ReactNode => {
			if (typeof node === 'string') {
				return node
			} else {
				let { props = null, component } = node
				const children = node.children && createChildren(node.children, data, styles)

				if (Components[component]) {
					if (data[component]) {
						props = { ...(props || {}), ...data[component] }
					}
					component = Components[component]
				}

				if (children !== undefined) {
					return /*#__PURE__*/ React.createElement(component, props, ...children)
				} else {
					return /*#__PURE__*/ React.createElement(component, props)
				}
			}
		}
	)
}

/**
 * This is the Content Body component
 * Most likely used in the "middle" part of an article template
 *
 * Splits out the html,
 * Inputs resource download button before and after content if it exists
 * Finds and places all the areas where RFQ is referenced
 */
export const ContentBody: React.FC<{
	bestPicks: object[]
	json: Node[]
	resource: object
	subtitle?: string
	template: string
	type: string
}> = ({ bestPicks, resource, json, subtitle, template, type = 'article' }) => {
	//Array to add inline styles serialized
	const styles: SerializedStyles[] = []

	//Inital children call
	const children: ReactNode[] = createChildren(
		json,
		//data to be injected on widgets by component
		{
			ContentResource: { resource, type },
			BestPicks: { bestPicks, template },
		},
		styles
	)

	return (
		<ContentWrapper>
			{subtitle && <h2>{subtitle}</h2>}
			<Content>{/*#__PURE__*/ React.createElement('main', null, ...children)}</Content>
		</ContentWrapper>
	)
}
